
import {Component, Prop} from "vue-property-decorator";
import ItemArrayManager from "@/components/common-inputs/ItemArrayManager.vue";
import NafakaAlacakKalemiForm from "@/components/forms/alacak-kalemi/NafakaAlacakKalemiForm.vue";
import AyEkleForm from "@/components/forms/AyEkleForm.vue";
import IlamBilgileriForm from "@/components/forms/alacak/IlamBilgileriForm.vue";
import Dates from "@/components/inputs/Dates.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import ParaBirimiPicker from "@/components/pickers/ParaBirimiPicker.vue";
import {AbstractFormWizard} from "@/abstract_classes/AbstractFormWizard";
import {IlamTipi} from "@/enum/IlamTipi";
import StepperValidationForm from "@/components/StepperValidationForm.vue";
import {TakipTalebiEntity} from "@/entity/TakipTalebiEntity";
import {TakipTarihliKurEntity} from "@/entity/TakipTarihliKurEntity";
import {TakipTipi} from "@/enum/TakipTipi";
import {TakipMahiyeti} from "@/enum/TakipMahiyeti";

@Component({
  components: {
    StepperValidationForm,
    ParaBirimiPicker,
    Tutar,
    Dates,
    NafakaAlacakKalemiForm,
    ItemArrayManager,
    IlamBilgileriForm,
    AyEkleForm,
  },
})
export default class IlamliNafakaAlacakFormWizard extends AbstractFormWizard {
  @Prop() takipTipiId!: number;
  @Prop() takipTalebi !: TakipTalebiEntity;
  @Prop() takipTarihliKurlar!: Array<TakipTarihliKurEntity>;

  activeStep = 1;
  ilamTipi = IlamTipi;

  get showNafakaBitisTarihi() {
    const takip = this.$store.state.takipDetay?.takip;
    const ilkTalep = takip?.takip_bilgileri?.talepler?.[0];
    const takipTipiId = ilkTalep?.takip_tipi_id;
    const takipMahiyetiId = ilkTalep?.takip_mahiyeti_id;

    return takipTipiId == TakipTipi.paraBorcuVeyaTeminat
        && (takipMahiyetiId == TakipMahiyeti.nafaka || takipMahiyetiId == TakipMahiyeti.ilamliNafaka);
  }

  stepperHeaders = [
    "Nafaka Alacağı",
    "Alacak Kalemi"
  ];
  defaultMahkeme = {
    ilam: 1,
    yargiBirimi: 12,
    dosya: 1
  }
  mounted() {
    this.$emit('hide-button', true);
    if (!this.localValue.asil_alacaklar) {
      this.localValue.asil_alacaklar = [];
    }
  }

  previousStepRules() {
    return true;
  }

  nextStepRules() {
    return true;
  }
}
